import {useContext} from "react";
import {EndOfShiftReportPayload} from "../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActionTypes";
import {DutyManagerReportEditableContext} from "../../Context/DutyManagerReportEditable";
import {useDispatch} from "react-redux";
import FormRow from "../../../../../../Form/FormRow";
import {DebounceInput} from "react-debounce-input";
import FormHeader from "../../../../../../Form/FormHeader";
import React from "react";
import {setPayload} from "../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActions";

const SafeguardingForm = (props: EndOfShiftReportPayload) => {
    const editable = useContext(DutyManagerReportEditableContext);
    const dispatch = useDispatch();

    const onChangeYes = () => {
        const payload: EndOfShiftReportPayload = {...props, isSafeguardComplete: true};
        dispatch(setPayload(payload));
    };
    const onChangeNo = () => {
        const payload: EndOfShiftReportPayload = {...props, isSafeguardComplete: false};
        dispatch(setPayload(payload));
    };

    return (
        <React.Fragment>
            <div className="eos-section">
                <FormHeader headerName="Safeguarding" />
                <FormRow rowName="Safeguarding Completed">
                    <label htmlFor="safeguarding-yes">
                        <input
                            id="safeguarding-yes"
                            type="radio"
                            checked={props.isSafeguardComplete}
                            disabled={!editable}
                            onChange={onChangeYes}
                            name="safeguarding-complete"
                        />
                        <span> Yes</span>
                    </label>
                    <label htmlFor="safeguarding-no">
                        <input
                            id="safeguarding-no"
                            type="radio"
                            checked={!props.isSafeguardComplete}
                            disabled={!editable}
                            onChange={onChangeNo}
                            name="safeguarding-complete"
                        />
                        <span> No</span>
                    </label>
                </FormRow>
                <FormRow rowName="Type of Safeguarding">
                    <DebounceInput
                        className="input-fields"
                        type="text"
                        value={props.safeguardingType}
                        onChange={(event) => {
                            const payload: EndOfShiftReportPayload = {
                                ...props,
                                safeguardingType: event.target.value
                            };
                            dispatch(setPayload(payload));
                        }}
                        disabled={!editable}
                    />
                </FormRow>
                <FormRow rowName="Referral Notes:">
                    <DebounceInput
                        className="input-fields text-area-inputs minimum"
                        element={"textarea"}
                        value={props.referralNotes}
                        onChange={(event) => {
                            const payload: EndOfShiftReportPayload = {
                                ...props,
                                referralNotes: event.target.value
                            };
                            dispatch(setPayload(payload));
                        }}
                        disabled={!editable}
                    />
                </FormRow>
            </div>
        </React.Fragment>
    );
};

export default SafeguardingForm;
